export default __webpack_public_path__ + "static/media/courseImg1.5fa38bed.png";